var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ConfigureButton',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isActivated),expression:"!isActivated"}]}),_c('CombinedButton',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActivated),expression:"isActivated"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }